import { _longPressTypes, LPW } from 'global/wrappers/LongPressWrapper'
import { useContext, useMemo } from 'react'
import { Card, Icon, Label } from 'semantic-ui-react'
import { AppSettingsContext } from '../../../cnr/contexts/AppSettingsContext'
import { ElementContext } from '../../../cnr/contexts/ElementContext'
import { PageAreaParentContext } from '../../../cnr/contexts/PageAreaParentContext'
import { UiItemContext } from '../../../cnr/contexts/UiItemContext'
import { clickToMethods } from '../../../cnr/reducers/ElementReducer'
import { uniqueKey } from '../../../common/keys'
import { gEnums } from '../../../enums/globalEnums'
import { _animateTypes } from '../../../motions/AnimateComponent'
import MotionComponent from '../../../motions/MotionComponent'
import { addCardImage } from '../../imaging/UiImage'
import { parentBreadcrumbs } from '../breadcrumbs'
import { cardSections, groupedSections } from '../cardSections'
import CardIndicator from './CardIndicator'
import LinkIcon from './LinkIcon'
import PdfIcon from './PdfIcon'
import { useCardElements } from 'global/cnr/contexts/useHelpers/useCardElements'

const CardNormal = (props) => {

  const { isSubCard } = props

  const { getCardElements } = useCardElements()

  // parentContext
  const parentContext = useContext(PageAreaParentContext)
  const { states } = parentContext ?? {}
  const { eventInfo_state, paps_state, transition_state } = states
  const { staticViews } = eventInfo_state ?? {}
  const { pathViews, trueView } = paps_state ?? {}

  // appSettingsContext
  const appSettingsContext = useContext(AppSettingsContext);
  const { appSettings_state } = appSettingsContext ?? {}
  const { directLinksOverrideOn } = appSettings_state ?? {}

  // uiItemContext 
  const uiItemContext = useContext(UiItemContext)
  const { item_state } = uiItemContext ?? {}
  const { viewItemStatus } = item_state ?? {}
  const { isViewItemSolo } = viewItemStatus ?? {}

  // elementContext
  const elementContext = useContext(ElementContext)
  const { element_state } = elementContext ?? {}
  const { itemData, elemProps, clickTo } = element_state ?? {}

  const {
    _display,
    _itemKey,
    _sections,
    aps_global,
    appUserAccess,
    cardImage,
    cardPrps,
    cardQr,
    divRef,
    getParents,
    handleClick,
    imageInContent,
    image_viewItem,
    index,
    noClick,
    page_fns,
    semSecProps,
    showItemIds,
    showItemImage,
    showQrCode,
    style,
    viewItem,
  } = elemProps ?? {}

  const { isSuperAdmin } = appUserAccess ?? {}
  const { cardDisplayType, showPdf } = _display ?? {}

  const { display: display_global } = aps_global ?? {}
  const { showDirectLinks, showAllLinks } = display_global ?? {}
  const { transitions } = transition_state ?? {}
  const transition = transitions ? transitions[_animateTypes.pageItemElement] : null
  const { showTransition } = transition ?? {}

  const _showTransition = showTransition && cardDisplayType.indexOf('Plus') < 0

  const { indicator } = viewItem ?? {}
  const { showIndicator, indicatorProp, indicatorLocation } = indicator ? indicator : {}
  const _indicatorLocation = indicatorLocation ? indicatorLocation : gEnums.bannerLocationTypes.bottom

  const _shows_card = {
    indicatorTop: showIndicator && indicatorProp && _indicatorLocation === gEnums.bannerLocationTypes.top,
    imageAbove: showItemImage && !imageInContent && !isSubCard,
    imageIn: showItemImage && imageInContent && !isSubCard,
    qrCode: showQrCode,
    indicatorBottom: showIndicator && indicatorProp && _indicatorLocation === gEnums.bannerLocationTypes.bottom
  }

  const _cardKeyy = uniqueKey('cpr', _itemKey)

  const groupedElements = useMemo(() => {
    const sectionGroupedElement = getCardElements({ _keyy: _cardKeyy, itemData, isSubCard })
    return sectionGroupedElement
  }, [itemData, _itemKey])

  let _hasDirectLink = false;
  let _isDirectLink = false;

  if (showDirectLinks && pathViews?.[trueView]) {
    const viewKey = pathViews?.[trueView]
    if (itemData?.[trueView] && itemData?.[trueView].includes(viewKey)) {
      _hasDirectLink = true
      if (directLinksOverrideOn) {
        _isDirectLink = true
      }
    }
  }

  const cardContent = () => {

    const cc = []
    let hasPdf;

    showItemIds && isSuperAdmin && cc.push(
      <div key={uniqueKey('sccid', index)} className='card-id'>
        <Label key={uniqueKey('cs', 'l', index)} attached='top right' size={'mini'} color={'grey'}>{_itemKey}</Label>
      </div>)

    if (clickTo && clickTo.showIcons) {
      switch (clickTo.clickToMethod) {
        case clickToMethods.openAppPdf:
          cc.push(<Icon name='file pdf outline' size='large' color='blue' style={{ float: 'right' }} />)
          hasPdf = true
          break;
        case clickToMethods.openAppUrl:
          cc.push(<Icon name='external alternate' size='large' color='blue' style={{ float: 'right' }} />)
          hasPdf = true
          break;
        default:
        // nothing
      }
    }

    // add breadcrumbs
    cc.push(parentBreadcrumbs(viewItem, getParents, page_fns))

    // add the sections 
    groupedElements && cc.push(groupedSections(groupedElements, semSecProps))
    cc.push(cardSections(_sections, semSecProps))

    return { cc, hasPdf }
  }

  // in useMemo
  const cardIndicator = () => <CardIndicator key={uniqueKey('sc', 'cn', 'ind', _itemKey)} indicator={indicator} cardKey={_cardKeyy} itemData={itemData} aps_global={aps_global} staticViews={staticViews} />

  const card = useMemo(() => {

    const { cc, hasPdf } = cardContent()

    let cn = 'card-content'
    if (hasPdf) { cn += ' pdf' }

    return <LPW
      itemData={itemData}
      longPressType={_longPressTypes.item}
    >
      <Card
        ref={divRef}
        key={uniqueKey('sccrd', _itemKey)}
        as='div'
        style={style}
        {...cardPrps}
        className={'card-normal ish'}
        fluid
        // onMouseMove={e => e.stopPropagation()}
        // onMouseOver={(e) => { handleHover() }} 
        onClick={() => handleClick(viewItem, _itemKey, null, { itemData: itemData, noClick, clickTo })}
      >
        {_shows_card.indicatorTop && cardIndicator()}
        {_shows_card.imageAbove && <Card.Content key={uniqueKey('sc', 'cn', 'img-t', _itemKey)} className={'card-image norm'}>{addCardImage(cardImage, image_viewItem, _display)}</Card.Content>}

        <Card.Content key={uniqueKey('sc', 'cn', 'mc', _itemKey)} className={cn}>
          {cc}
          {(!isViewItemSolo && (_hasDirectLink || showAllLinks)) && <LinkIcon _keyy={_cardKeyy} hasDirectLink={_hasDirectLink} showAllLinks={showAllLinks} />}
          {showPdf && itemData?.itemPdf && <PdfIcon _keyy={_cardKeyy} itemPdf={itemData.itemPdf} />}
        </Card.Content>

        {_shows_card.imageIn && <Card.Content key={uniqueKey('sc', 'cn', 'img-i', _itemKey)} className={'card-image norm'}>{addCardImage(cardImage, image_viewItem, _display)}</Card.Content>}
        {_shows_card.qrCode && <Card.Content key={uniqueKey('sc', 'cn', 'qr', _itemKey)} className={'card-qr'}>{cardQr}</Card.Content>}
        {_shows_card.indicatorBottom && cardIndicator()}
      </Card>
    </LPW>
  }, [groupedElements])

  if (_showTransition) {
    return <MotionComponent
      transition={transition}
    >
      {card}
    </MotionComponent>
  } else {
    return card
  }

}

export default CardNormal
